import { render } from "./Lens.vue?vue&type=template&id=845cd8c4"
import script from "./Lens.vue?vue&type=script&lang=js"
export * from "./Lens.vue?vue&type=script&lang=js"

import exportComponent from "/Users/thuanluu/code/owlx/more9_venues/package/private/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Lens.vue"]])

export default __exports__